import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CustomLoadingOverlay from '../../common/datagrid/CustomLoadingOverlay';

const OrderBookHistoryList = ({ apiRef, columns, rows, loading , handleRowClick}) => {
  return (
    <div style={{ display: 'flex', height: '350px' }}>
    <div style={{ flexGrow: 1 }}>
        <DataGridPro
          rows={rows ? rows : []}
          columns={columns}
          components={{
            LoadingOverlay: CustomLoadingOverlay,
          }}
          loading={loading}
          apiRef={apiRef}
          onRowClick={handleRowClick}
        />
      </div>
    </div>
  );
};

export default OrderBookHistoryList;
